import React, { useState, useEffect } from 'react';
import { MdArrowBack, MdAccountBalanceWallet, MdInfoOutline, MdLock } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { db } from "../firebase";
import { ref, onValue, push, serverTimestamp, update } from "firebase/database";
import Swal from 'sweetalert2';
import './Withdraw.css';
import { useTranslation } from 'react-i18next'; // Hook import kiya

const Withdraw = () => {
    const { t } = useTranslation(); // Translation injection
    const [amount, setAmount] = useState('');
    const [balance, setBalance] = useState(0);
    const [boundWallet, setBoundWallet] = useState({
        name: "Not Bound",
        address: "Please bind a wallet first"
    });

    const navigate = useNavigate();
    const savedUser = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (savedUser?.username) {
            const userRef = ref(db, `users/${savedUser.username}`);
            onValue(userRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setBalance(parseFloat(data.balance) || 0);
                    if (data.paymentMethod) {
                        setBoundWallet({
                            name: data.paymentMethod.walletName,
                            address: data.paymentMethod.address
                        });
                    }
                }
            });
        }
    }, [savedUser?.username]);

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/'); 
        }
    };

    const handleWithdraw = async () => {
        const val = parseFloat(amount);

        if (boundWallet.name === "Not Bound" || !boundWallet.address) {
            return Swal.fire('Error', t('bind_wallet_error'), 'error');
        }

        if (!val || val < 10) {
            return Swal.fire({
                icon: 'warning',
                title: t('min_withdraw_title'),
                text: t('min_withdraw_text'),
                confirmButtonColor: '#f3ba2f'
            });
        }

        if (val > balance) {
            return Swal.fire({
                icon: 'error',
                title: t('insufficient_balance_title'),
                text: t('insufficient_balance_text'),
                confirmButtonColor: '#f3ba2f'
            });
        }

        Swal.fire({
            title: t('processing_title'),
            text: t('submitting_text'),
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        try {
            const newWithdrawRef = push(ref(db, 'withdrawals'));
            const requestId = newWithdrawRef.key;
            const newBalance = (balance - val).toFixed(2);

            // Transaction History Entry Logic
            const newTransactionRef = push(ref(db, 'transactions'));
            const transId = newTransactionRef.key;

            const updates = {};
            updates[`/users/${savedUser.username}/balance`] = newBalance;
            
            // 1. Withdrawals Node (Admin ke liye)
            updates[`/withdrawals/${requestId}`] = {
                username: savedUser.username,
                amount: val,
                walletName: boundWallet.name,
                address: boundWallet.address,
                status: 'pending',
                timestamp: serverTimestamp(),
                requestId: requestId
            };

            // 2. Transactions Node (User ki History ke liye)
            updates[`/transactions/${transId}`] = {
                username: savedUser.username,
                type: 'Withdraw',
                amount: val,
                status: 'Pending', // Audit hone tak pending show hoga
                timestamp: serverTimestamp(),
                details: `Withdrawal to ${boundWallet.name}`,
                requestId: requestId // Dono ko link kar diya taake update karne mein asani ho
            };

            await update(ref(db), updates);

            Swal.fire({
                icon: 'success',
                title: t('req_submitted_title'),
                text: t('funds_arrive_text'),
                timer: 2000,
                showConfirmButton: false
            });
            
            setTimeout(() => navigate('/'), 2000);
        } catch (error) {
            Swal.fire('Error', 'Failed: ' + error.message, 'error');
        }
    };

    return (
        <div className="withdraw-luxury-wrapper">
            <div className="withdraw-nav">
                <MdArrowBack onClick={handleBack} className="nav-icon" />
                <span>{t('withdraw_title')}</span>
                <div className="nav-spacer"></div>
            </div>

            <div className="withdraw-container">
                <div className="balance-mini-card">
                    <p>{t('available_balance')}</p>
                    <h2>{balance.toFixed(2)} <span>USDT</span></h2>
                </div>

                <div className="wallet-bound-section">
                    <div className="section-label">
                        <span>{t('withdrawal_method')}</span>
                        <div className="lock-badge"><MdLock size={12}/> {t('fixed_badge')}</div>
                    </div>
                    
                    <div className="bound-card">
                        <div className="wallet-info">
                            <div className="wallet-icon-circle">
                                <MdAccountBalanceWallet size={24} color="#f3ba2f" />
                            </div>
                            <div className="wallet-details">
                                <strong>{boundWallet.name === "Not Bound" ? t('not_bound') : boundWallet.name}</strong>
                                <p style={{ wordBreak: 'break-all' }}>{boundWallet.name === "Not Bound" ? t('please_bind_first') : boundWallet.address}</p>
                            </div>
                        </div>
                        <div className="network-tag">TRC20</div>
                    </div>
                    <p className="hint-text"><MdInfoOutline/> {t('change_wallet_hint')}</p>
                </div>

                <div className="amount-input-section">
                    <label>{t('withdrawal_amount')}</label>
                    <div className="premium-input-box">
                        <input 
                            type="number" 
                            placeholder={t('min_placeholder')} 
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                        <button onClick={() => setAmount(balance.toString())} className="all-btn">{t('all_btn')}</button>
                    </div>
                    <div className="fee-info">
                        <span>{t('service_fee')}</span>
                        <span>{t('will_receive')}: ${amount ? (parseFloat(amount) * 0.97).toFixed(2) : "0.00"}</span>
                    </div>
                </div>

                <div className="warning-notice">
                    <ul>
                        <li>{t('audit_notice_1')}</li>
                        <li>{t('audit_notice_2')}</li>
                    </ul>
                </div>

                <button className="withdraw-submit-btn" onClick={handleWithdraw}>
                    {t('confirm_withdrawal_btn')}
                </button>
            </div>
        </div>
    );
};

export default Withdraw;